import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { entityKeys } from "../queryKeys";
import { getFootballFacilities } from "../services/footballFacilities.service";

export const useFootballFacilities = () => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [entityKeys.footballFacilities, i18n.language],
    queryFn: getFootballFacilities,
  });
};
